<template>
  <span v-if="notificationUnreadCount" class="notification-count">{{
    notificationUnreadCount
  }}</span>
</template>

<script>
/*
Powers the unread notification count in User Nav dropdown
*/

// @flow
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'

export default {
  name: 'NotificationCount',
  props: {},
  data() {
    return {}
  },

  computed: {
    ...mapState(useUserAuthStore, ['user']),

    notificationUnreadCount() {
      if (
        this.user &&
        this.user.notificationUnreadCount &&
        this.user.notificationUnreadCount >= 0
      ) {
        return this.user.notificationUnreadCount >= 99 ? '99+' : this.user.notificationUnreadCount
      }

      return ''
    },
  },
}
</script>
